"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerAttributeTypes = exports.BannerStatus = exports.BannerProduct = exports.BannerType = void 0;
var BannerType;
(function (BannerType) {
    BannerType["INFO"] = "INFO";
    BannerType["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
    BannerType["ONGOING_ISSUE"] = "ONGOING_ISSUE";
})(BannerType = exports.BannerType || (exports.BannerType = {}));
var BannerProduct;
(function (BannerProduct) {
    BannerProduct["ALL"] = "ALL";
    BannerProduct["MYNDVIEW"] = "MYNDVIEW";
    BannerProduct["MYNDCONTROL"] = "MYNDCONTROL";
    BannerProduct["PASUBMIT"] = "PASUBMIT";
    BannerProduct["PACENTRAL"] = "PACENTRAL";
})(BannerProduct = exports.BannerProduct || (exports.BannerProduct = {}));
var BannerStatus;
(function (BannerStatus) {
    BannerStatus["ACTIVE"] = "ACTIVE";
    BannerStatus["INACTIVE"] = "INACTIVE";
})(BannerStatus = exports.BannerStatus || (exports.BannerStatus = {}));
var BannerAttributeTypes;
(function (BannerAttributeTypes) {
    BannerAttributeTypes["PATH"] = "path";
    BannerAttributeTypes["EMAIL"] = "email";
    BannerAttributeTypes["PRODUCT"] = "product";
})(BannerAttributeTypes = exports.BannerAttributeTypes || (exports.BannerAttributeTypes = {}));
//# sourceMappingURL=types.js.map